import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function PageShell({ children, showFooter = true, testid }) {
  return (
    <div className="min-h-screen flex flex-col bg-sprouts-bg" data-testid={testid}>
      <Header />
      <main className="flex-1">{children}</main>
      {showFooter && <Footer />}
    </div>
  );
}
